import React from 'react';
import Header from '../../componentes/comuns/Header';
import Quemsomos from '../../componentes/comuns/Quemsomos';
import Footer from '../../componentes/comuns/Footer';
import Contato from '../../componentes/comuns/Contato';
import InfinitePossibilities from '../../componentes/comuns/InfinitePossibilities';

const Pagina2 = () => {
    return (
        <>
            <Header />
            <main>
                <div>
                    <Quemsomos/>
                </div>
                <div>
                    <Contato />
                </div>
                <div>
                    <InfinitePossibilities />
                </div>
            </main>
            <Footer />
        </>
    );
}

export default Pagina2;